import React from 'react'

export default function Footer() {
    return (
        <div>
            {process.env.REACT_APP_FOOTER_ENABLED==="true" && <div style={{ width: '100%' }}><div id="footer" className="footer" ></div></div>}
        </div>
    )
}
